import { useCallback, useEffect, useRef, useState } from "react";
import { ArrowUpIcon } from "@exact-magic/icons";
import Textarea from "react-textarea-autosize";

import { Button } from "../../ui/button";
import { useEnterSubmit } from "../../hooks/use-enter-submit";
import { useChat } from "../../context/use-chat";
import { useUI } from "../../context/ui";

export const TextPrompt = () => {
  const { ui } = useUI();
  const { formRef, onKeyDown } = useEnterSubmit();
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const { isLoading, append, input, setInput } = useChat();

  useEffect(() => {
    if (inputRef.current && !isLoading) {
      inputRef.current.focus();
    }
  }, [inputRef, isLoading]);

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setInput(e.target.value || "");
    },
    [],
  );

  return (
    <div className="p-3">
      <form
        ref={formRef}
        className="flex flex-none flex-col bg-background"
        onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
          e.preventDefault();
          if (input) {
            append(input);
            setInput("");
          }
        }}
      >
        <div className="relative overflow-hidden">
          <Textarea
            ref={inputRef}
            tabIndex={0}
            onKeyDown={onKeyDown}
            spellCheck={false}
            autoComplete="off"
            autoCorrect="off"
            className="w-full resize-none rounded-md border py-3.5 pl-4 pr-14 align-top text-base shadow-sm outline-none transition-colors duration-100 focus:border-slate-900"
            rows={1}
            placeholder="Envie uma mensagem..."
            value={input}
            onChange={handleInputChange}
            disabled={isLoading}
          />
          <div className="absolute bottom-1.5 right-1.5 flex items-end">
            <Button
              size="icon"
              type="submit"
              className="rounded-md text-white"
              disabled={isLoading || !input}
            >
              <ArrowUpIcon className="size-5" />
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};
